module.exports = __webpack_public_path__ + "static/media/decticus_verrucivorus_002_APA.e1bd3f12.mp3";